import React from "react";
import Skill from "../components/skill";
import style from "../styles/skills.module.css";
import Reveal from "../components/reveal";
import { skillGroups } from "../data/profile";

const Skills = () => (
  <section id="skills" className={`sectionShell ${style.skills}`}>
    <div className="sectionInner">
      <Reveal dir="up" amount={0.4}>
        <h2 className="sectionHeading" data-outline="Skills">
          Skills
        </h2>
      </Reveal>

      <div className={style.groups}>
        {skillGroups.map((group, gi) => (
          <Reveal
            dir="up"
            delay={gi * 0.06}
            amount={0.1}
            key={group.id}
            className={style.group}
          >
            <div className={style.groupHead}>
              <span className={`${style.groupLine} ${style.groupLineLeft}`} />
              <span className={style.groupIndex}>0{gi + 1}</span>
              <h3 className={style.groupTitle}>{group.title}</h3>
              <span className={style.groupLine} />
            </div>
            <div className={style.grid}>
              {group.skills.map((name, si) => (
                <Skill key={name} name={name} delay={si * 0.04} />
              ))}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Skills;
